import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { ThemeProvider } from "./context/ThemeContext";
import { AuthProvider } from "./context/AuthContext";
import { GuestProvider } from "./context/GuestContext";
import { GuestPrompts } from "./components/GuestPrompts";
import ScrollToTop from "./components/ScrollToTop";
import PWAInstallPrompt from "./components/PWAInstallPrompt";
import LandingPage from "./pages/LandingPage";
import AuthPage from "./pages/AuthPage";
import AuthCallbackPage from "./pages/AuthCallbackPage";
import DashboardPage from "./pages/DashboardPage";
import ScanResultPage from "./pages/ScanResultPage";
import ReleaseSchedulePage from "./pages/ReleaseSchedulePage";
import ProfitCalculatorPage from "./pages/ProfitCalculatorPage";
import InventoryPage from "./pages/InventoryPage";
import HistoryPage from "./pages/HistoryPage";
import PricingPage from "./pages/PricingPage";
import ProfilePage from "./pages/ProfilePage";
import SettingsPage from "./pages/SettingsPage";
import SubscriptionPage from "./pages/SubscriptionPage";
import ReferralPage from "./pages/ReferralPage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import ContactPage from "./pages/ContactPage";
import RefundPage from "./pages/RefundPage";
import NotFoundPage from "./pages/NotFoundPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import FeedbackPage from "./pages/FeedbackPage";
import SharePage from "./pages/SharePage";
import "./App.css";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <GuestProvider>
          <BrowserRouter>
            <ScrollToTop />
            {/* Responsive container - full width on desktop, mobile-friendly */}
            <div className="App min-h-screen bg-background">
              <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/auth" element={<AuthPage />} />
                <Route path="/auth/callback" element={<AuthCallbackPage />} />
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/search/:scanId" element={<ScanResultPage />} />
                <Route path="/scan/:scanId" element={<Navigate to={window.location.pathname.replace('/scan/', '/search/')} replace />} />
                <Route path="/releases" element={<ReleaseSchedulePage />} />
                <Route path="/calculator" element={<ProfitCalculatorPage />} />
                <Route path="/inventory" element={<InventoryPage />} />
                <Route path="/history" element={<HistoryPage />} />
                <Route path="/pricing" element={<PricingPage />} />
                <Route path="/profile" element={<ProfilePage />} />
                <Route path="/settings" element={<SettingsPage />} />
                <Route path="/subscription" element={<SubscriptionPage />} />
                <Route path="/subscription/success" element={<SubscriptionPage />} />
                <Route path="/referral" element={<ReferralPage />} />
                <Route path="/privacy" element={<PrivacyPage />} />
                <Route path="/terms" element={<TermsPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/refund" element={<RefundPage />} />
                <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                <Route path="/reset-password" element={<ResetPasswordPage />} />
                <Route path="/feedback" element={<FeedbackPage />} />
                <Route path="/share/:shareCode" element={<SharePage />} />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
              <GuestPrompts />
              <PWAInstallPrompt />
              <Toaster position="top-center" richColors />
            </div>
          </BrowserRouter>
        </GuestProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
